import * as React from 'react';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { useParams } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import ReCAPTCHA from 'react-google-recaptcha';
// import UserIcon from '/images/design_useroutlined.png';
import { Get, Post } from '../services/http';
import { validateForm } from '../services/validate';
import { CheckoutForm } from '../components/stripe/checkout-form';
import TermsPopup from '../dialogs/terms-popup';
import { BanquestCreditCard } from '../components/payments/banquest-credit-card';
import { BanquestCheck } from '../components/payments/banquest-check';
import { GetCommission } from '../services/commission';
import { DonorFund } from '../components/payments/donor-fund';
import UserIcon from '../images/design_useroutlined.png';
import EmailIcon from '../images/email.png';
import PhoneIcon from '../images/phone.png';


// const stripePromise = loadStripe('pk_test_51KT4vrEOOhnAZ3csWL7xnQ6qqlynFPLtZstQm6kPW6UWS823KbqVrVfTzDrAV0JA9notCL43y2C3ujf3LjO9d1NS00fTwjReHR');
const stripePromise = loadStripe('pk_live_51I6ia1AML6gYgMNZ2LdFzEVGWNEyVFGdCxDJ9A5BXkyiVhW1Ock75IwHjRUxICW2LXl7q5M45QHnSTRYUgzjekW1005h3AM99T');
let globalDonationID;

export default function CheckoutPage() {
    const [campaign, setCampaign] = React.useState(false);
    const [donationID, setDonationID] = React.useState(null);
    const [donationTotal, setDonationTotal] = React.useState(null);
    const [stripeIntentID, setStripeIntentID] = React.useState(null);
    const [partnerSlug, setPartnerSlug] = React.useState(null);
    const [paymentProcessor, setPaymentProcessor] = React.useState(null);
    const [paymentMethod, setPaymentMethod] = React.useState(null);
    const [tipPercent, setTipPercent] = React.useState(null);
    const [tipGeneral, setTipGeneral] = React.useState(null);
    const [subscriptionId, setSubscriptionId] = React.useState(null);
    const [currencyIndicator, setCurrencyIndicator] = React.useState(null);
    const [currencyOpen, setCurrencyOpen] = React.useState(false);
    const [reccuringTerm, setReccuringTerm] = React.useState('weekly');
    const [tipPercentValue, setTipPercentValue] = React.useState(4);
    const [reccuringModeIndicator, setReccuringModeIndicator] = React.useState('single');
    const [donationSumIndicator, setDonationSumIndicator] = React.useState(0);
    const [openACH, setOpenACH] = React.useState(false);
    const paymentNumList = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    const [paymentsNumOpen, setPaymentsNumOpen] = React.useState(false);
    const [openReccuringPayments, setOpenRecurringPayments] = React.useState(null);
    const [maxPayments, setMaxPayments] = React.useState(2);
    const currencyList = ['$', '€', 'C$', 'A$', '£'];
    const openInfoPopup = useStoreActions((actions) => actions.open);
    let { campaignSlug, donationSum, currency } = useParams();
    const config = useStoreState((state) => state.config);
    const recurringTermsList = ['weekly', 'bi-weekly', 'monthly', 'quaterly'];
    const [termsPopup, setTermsPopup] = React.useState(null);
    const [orderID, setOrderID] = React.useState(false);
    const [openPaypal, setOpenPaypal] = React.useState(false);
    const [openPaypalCheckout, setOpenPaypalCheckout] = React.useState(false);
    const [openDonorFund, setOpenDonorFund] = React.useState(false);
    const [isCaptcha, setIsCaptcha] = React.useState(true);
    const [clientIP, setClientIP] = React.useState(false);

    const togglePaymentsNum = () => {
        const newPaymentsOpen = !paymentsNumOpen;
        setPaymentsNumOpen(newPaymentsOpen);
    };

    function isCaptchaValid(value) {
        if (value !== null || value !== '') {
            setIsCaptcha(true);
        }
    }

    const getCurrencyValue = (name) => {
        switch (name) {
            case '€':
                return 'eur';
            case 'C$':
                return 'CAD';
            case 'A$':
                return 'AUD';
            case '$':
                return 'USD';
            case '£':
                return 'gbp';
            default:
                return 'eur';
        }
    };

    const updateCommissionAmountTip = (commPayMethod, commPayProcessor, commPayAmount) => {
        const newAmount = GetCommission(commPayMethod, commPayProcessor, commPayAmount);
        setTipPercentValue(newAmount);
    };

    const selectMaxPayments = (newMaxPayment) => {
        setMaxPayments(newMaxPayment);
        setPaymentsNumOpen(false);
    };

    const createUpdateDonation = async (id = null) => {
        const result = await Post('/api/donation/UpdateCreateDonation', {
            id,
            name: document.getElementById('first-name').value,
            familyName: document.getElementById('last-name').value,
            firstName: document.getElementById('first-name').value,
            lastName: document.getElementById('last-name').value,
            ambassadorSlug: partnerSlug,
            recurringMode: reccuringModeIndicator,
            recurringTerm: reccuringTerm,
            currency: currencyIndicator,
            total: parseFloat(donationTotal),
            status: 'pending',
            dedication: document.getElementById('donation-note').value,
            mobilePhoneNum: document.getElementById('phone-number').value,
            email: document.getElementById('email').value,
            isAnonymous: document.getElementById('anonymous-checkbox').checked,
            displayName: document.getElementById('display-name').value,
            paymentMethod,
            subscriptionId,
            maxPayments: maxPayments === 'ongoing' ? 0 : maxPayments,
            paymentType: paymentProcessor,
            tipPercentSum: parseFloat(tipPercent),
            tipGeneralSum: parseFloat(tipGeneral),
            donationCampaignId: campaign?.id,
            sum: parseInt(donationSumIndicator),
            // companyName: document.getElementById('company-name').value,
            stripePaymentIntentID: stripeIntentID
        });
        setDonationID(result.donationID);
        // console.log('stripe debug donationID from server set', result.donationID);
        return result;
    };

    const createOrder = (data, actions) => {
        const currencyValue = getCurrencyValue(currencyIndicator).toUpperCase();
        const donationStripeAmount = parseFloat(donationTotal);
        // console.log('donationStripeAmount', donationStripeAmount);
        // console.log('currencyValue', currencyValue);
        console.log('globalDonationID', globalDonationID);
        return actions.order
            .create({
                purchase_units: [
                    {
                        reference_id: globalDonationID,
                        description: 'order id: ' + globalDonationID.toString() + ' '
                            + document.getElementById('first-name').value + ' '
                            + document.getElementById('last-name').value + ' '
                            + '||| ' + campaign?.name + ' '
                            + 'id: ' + campaign?.id,
                        amount: {
                            currency_code: currencyValue,
                            value: donationStripeAmount,
                        },
                    },
                ],
                // not needed if a shipping address is actually needed
                application_context: {
                    shipping_preference: 'NO_SHIPPING',
                },
            })
            .then((orderId) => {
                setOrderID(orderId);
                return orderId;
            });
    };

    const getDonationValues = async () => {
        const donationServer = await Get('/api/donation/GetDonation', { id: donationID });
        const donationData = donationServer.donation;
        if (donationData !== null) {
            if (donationData.name !== '' && donationData.name != null) {
                const splitName = donationData.name?.split(' ');
                const firstName = splitName[0];
                const lastName = splitName.length > 1 ? splitName[1] : '';
                document.getElementById('first-name').value = firstName;
                document.getElementById('last-name').value = lastName;
            }
            document.getElementById('donation-note').value = donationData.dedication !== null && donationData.dedication !== 'null' ? donationData.dedication : '';
            document.getElementById('phone-number').value = donationData.mobilePhoneNum !== null && donationData.mobilePhoneNum !== 'null' ? donationData.mobilePhoneNum : '';
            document.getElementById('email').value = donationData.email !== null && donationData.email !== 'null' ? donationData.email : '';
            document.getElementById('anonymous-checkbox').checked = donationData.isAnonymous !== null ? donationData.isAnonymous : false;
        }
    };

    React.useEffect(() => {
        if (donationID !== null) {
            getDonationValues();
        }
    }, [donationID]);

    const showReccuringPaymentsWidget = (recurrPaymentMethod) => {
        console.log('recurring', recurrPaymentMethod);
        if (recurrPaymentMethod === 'Credit Card' || recurrPaymentMethod === 'check' || recurrPaymentMethod === 'donorFund') {
            setOpenRecurringPayments(true);
        } else {
            setOpenRecurringPayments(false);
        }
    };

    const getCampaignData = async () => {
        const projectData = await Get('/api/donation/GetProjectBySlug', { slug: campaignSlug });
        setCampaign(projectData.campaign);
    };

    const toggleCurrency = () => {
        const isOpen = !currencyOpen;
        setCurrencyOpen(isOpen);
    };

    const updateTermsPopup = (value) => {
        setTermsPopup(value);
    };

    const showACH = (achNewCurrency) => {
        if (achNewCurrency === '$') {
            setOpenACH(true);
        } else {
            setOpenACH(false);
        }
    };

    const showPayPal = (paypalNewCurrency) => {
        if (paypalNewCurrency === '$') {
            setOpenPaypal(true);
        } else {
            setOpenPaypal(false);
        }
    };

    const getSecret = async () => {
        const validateResult = validateForm(['first-name', 'terms-checkbox', 'last-name', 'email']); // if create don't need to validate form
        console.log('test', isCaptcha);
        if (!validateResult.result) {
            // // console.log('ssss something wrong from server!', result);
            openInfoPopup({ notice: validateResult.notice, reload: false, btnName: 'OK' });
            return;
        }
        if (!isCaptcha) {
            // // console.log('ssss something wrong from server!', result);
            openInfoPopup({ notice: 'please mark the captcha box', reload: false, btnName: 'OK' });
            return;
        }
        const currencyValue = getCurrencyValue(currencyIndicator);
        const donationStripeAmount = parseFloat(donationTotal) * 100;
        // console.log('donationStripeAmount', donationStripeAmount);
        const result = await Get('/api/stripe/GetStripeSecret', {
            recurringMode: reccuringModeIndicator,
            recurringTerm: reccuringTerm,
            email: document.getElementById('email').value,
            maxPayments,
            donationTotal: donationStripeAmount,
            currencyValue, // currency
            description: 'order id: ' + donationID?.toString() + ' '
                + document.getElementById('first-name').value + ' '
                + document.getElementById('last-name').value + ' '
                + '||| ' + campaign?.name + ' '
                + 'id: ' + campaign?.id
        });
        // console.log('result', result);

        // console.log('result.SubscriptionId', result?.subsResult?.subscriptionId);
        if (reccuringModeIndicator === 'recurring') {
            setSubscriptionId(result?.subsResult?.subscriptionId);
            setStripeIntentID(result?.subsResult?.clientSecret);
        } else {
            // console.log('clientSEcret', result?.clientSecret);
            setStripeIntentID(result?.clientSecret);
        }

        // // console.log('restult', result);
    };

    const getSecretPayPal = async () => {
        const validateResult = validateForm(['first-name', 'terms-checkbox', 'last-name', 'email', 'donation-amount']); // if create don't need to validate form
        if (!validateResult.result) {
            openInfoPopup({ notice: validateResult.notice, reload: false, btnName: 'OK' });
            return;
        }
        if (!isCaptcha) {
            // // console.log('ssss something wrong from server!', result);
            openInfoPopup({ notice: 'please mark the captcha box', reload: false, btnName: 'OK' });
            return;
        }
        setOpenPaypalCheckout(true);
        const resultId = await createUpdateDonation();
        globalDonationID = resultId.donationID;
        console.log('globalDonationID', globalDonationID);
    };

    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        } else {
            return '';
        }
    };

    const pay = async () => {
        // // console.log('donationID start pay', donationID);
        const validateResult = validateForm(['first-name', 'terms-checkbox', 'last-name', 'email', 'donation-amount']); // if create don't need to validate form
        const result = await createUpdateDonation(donationID);
        if (!result.result) {
            openInfoPopup({ notice: result.message, reload: false, btnName: 'OK' });
        }
        if (!isCaptcha) {
            return { notice: 'please mark the captcha  box', reload: false, btnName: 'OK' };
        }
        if (!validateResult.result) {
            return { notice: validateResult.notice, result: false };
        }
        if (!validateResult.result || !result.result) {
            // // console.log('ssss something wrong', validateResult.result);
            return { result: false };
        } else {
            // // console.log('ssss everything works', result);
            return { result: true };
        }
    };

    const getPartnerSlug = () => {
        const partnerSlugByCookie = getCookie('partnerSlug');
        // // console.log('partnerSlugByCookie', partnerSlugByCookie);
        setPartnerSlug(partnerSlugByCookie);
    };

    const appearance = {
        theme: 'night',
        /*  variables: {
             colorPrimary: '#0570de',
             colorBackground: 'green',
             colorText: '#30313d',
             colorDanger: '#df1b41',
             fontFamily: 'Ideal Sans, system-ui, sans-serif',
             spacingUnit: '2px',
             borderRadius: '4px',
             // See all possible variables below
         } */
    };

    const showNewPaymentMethod = (newMethodType) => {
        const paymentMethodInput = document.getElementById('payment-method-radio-id-' + newMethodType);
        if (paymentMethodInput !== null) {
            paymentMethodInput.checked = true;
        }
    };
    // const ]openPaypal, setOpenPaypal   

    const calculateAll = (calcDonSum, calcCommissionSum) => {
        let generalTipAmount = null;
        if (document.getElementById('general-tip')) {
            generalTipAmount = parseInt(document.getElementById('general-tip').value);
        }
        // current donationSum
        let subTotal = parseInt(calcDonSum);
        // console.log('subTotal after indicator', subTotal);
        if (generalTipAmount > 0) {
            subTotal += generalTipAmount; /// final general tip
        }
        // get percent tip
        let isAddPercentTip = null;
        if (document.getElementById('percent-tip')) {
            isAddPercentTip = document.getElementById('percent-tip').checked;
        }
        // console.log('tip test isAddPercentTip', isAddPercentTip);
        const newPercentTipAmount = isAddPercentTip ? calcCommissionSum : null;
        // console.log('tip test newPercentTipAmount', newPercentTipAmount); // final   
        const donationTotalResult = isAddPercentTip ? subTotal + parseFloat(newPercentTipAmount) : subTotal; // final donation total
        return { generalTipAmount, newPercentTipAmount, donationTotalResult, donationSum: calcDonSum };
    };

    const showDonorFund = (cNewCurrency) => {
        if (cNewCurrency === '$') {
            setOpenDonorFund(true);
        } else {
            setOpenDonorFund(false);
        }
    };

    const setPaypalProcessor = (paypalPaymentMethod) => {
        if (paypalPaymentMethod === 'paypal') { // force Credit Card when 
            setPaymentProcessor('paypal');
        }
    };

    const setDonorFundProcessor = (donorFundPaymentMethod) => {
        if (donorFundPaymentMethod === 'donorFund') { // force Credit Card when 
            setPaymentProcessor('donorFund');
        }
    };

    const doAllCalculation = (newDonationSum = null,
        newCurrency = null,
        newPaymentProcessor = null,
        newPaymentMethod = null) => {
        // first write down all that set limits on something
        let cNewDonationSum = newDonationSum !== null ? newDonationSum : donationSumIndicator;
        let cNewCurrency = newCurrency !== null ? newCurrency : currencyIndicator;
        let cNewPaymentProcessor = newPaymentProcessor !== null ? newPaymentProcessor : paymentProcessor;
        let cNewPaymentMethod = newPaymentMethod !== null ? newPaymentMethod : paymentMethod;
        // currency        
        setCurrencyOpen(false);
        setCurrencyIndicator(cNewCurrency);
        // currency
        // paymentMethod
        if (cNewPaymentMethod === 'check' && cNewCurrency !== '$') { // force Credit Card when 
            cNewPaymentMethod = 'Credit Card';
        }
        setPaymentMethod(cNewPaymentMethod);
        // paymentMethod
        // paymentProcessor
        if ((cNewPaymentProcessor === 'paypal' || cNewPaymentProcessor === 'stripe') && cNewPaymentMethod === 'check') { // force go to banquest if check won't happen ever
            cNewPaymentProcessor = 'banquest';
        }
        if (newCurrency !== null) {
            if (cNewCurrency !== '$') {
                cNewPaymentProcessor = 'stripe';
            } else {
                cNewPaymentProcessor = 'banquest';
            }
        }

        if (cNewPaymentMethod === 'Credit Card' || cNewPaymentMethod === 'check') {
            if (cNewCurrency !== '$') {
                cNewPaymentProcessor = 'stripe';
            } else {
                cNewPaymentProcessor = 'banquest';
            }
        }

        setPaymentProcessor(cNewPaymentProcessor);
        // paymentProcessor
        // calculate total without commission
        const totalWithoutCommission = calculateAll(cNewDonationSum, 0); // when we pass commission 0 it will surely return total without commission
        console.log('recurring midlle cNewPaymentMethod', cNewPaymentMethod);
        console.log('recurring midlle cNewPaymentProcessor', cNewPaymentProcessor);
        // calculate total without commission
        // donationCommission
        // console.log('debug commission all params', cNewPaymentMethod + '' + cNewPaymentProcessor);
        const cNewDonationCommission = GetCommission(cNewPaymentMethod, cNewPaymentProcessor, totalWithoutCommission.donationTotalResult);
        setTipPercentValue(cNewDonationCommission);
        // donationCommission
        // calculateTotals
        const allCalcResult = calculateAll(cNewDonationSum, cNewDonationCommission);
        setTipGeneral(allCalcResult.generalTipAmount);
        setTipPercent(allCalcResult.newPercentTipAmount);
        setDonationTotal(allCalcResult.donationTotalResult);
        // calculateTotals
        // showFields
        setDonationSumIndicator(cNewDonationSum);
        // console.log('show ach check by donation sumNew and processor', newDonationSum + ' ' + cNewPaymentProcessor);
        showACH(cNewCurrency);
        showPayPal(cNewCurrency);
        showDonorFund(cNewCurrency);
        showReccuringPaymentsWidget(cNewPaymentMethod);
        showNewPaymentMethod(cNewPaymentMethod);
        setPaypalProcessor(cNewPaymentMethod);
        setDonorFundProcessor(cNewPaymentMethod);
        // showFields
    };

    const updateDonationAmount = () => {
        validateForm(['donation-amount']);
        const updatedDonationSum = document.getElementById('donation-amount').value;
        doAllCalculation(updatedDonationSum);
    };

    React.useEffect(() => {
        setStripeIntentID(null);
    }, [donationTotal]);

    const selectRecurringTerm = (newTerm) => {
        setReccuringTerm(newTerm);
    };

    const selectReccuringMode = (newMode) => {
        setReccuringModeIndicator(newMode);
    };

    const goToThankYouPage = (returnUrl) => {
        window.location.href = returnUrl;
    };

    const onApprovePaypal = (data, actions) => {
        goToThankYouPage(config.frontDomain + 'thank-you/donation/' + donationID);
        return actions.order.capture().then((details) => {
            const name = details.payer.name.given_name;
            alert(`Transaction completed by ${name}`);
        });
    };

    const getClientIP = () => {
        fetch('https://api.ipify.org?format=json')
            .then((response) => {
                return response.json();
            }, 'jsonp')
            .then((res) => {
                console.log('res.ip', res.ip);
                const { ip } = res.ip;
                setClientIP(ip);
            });
    };

    const [checkBool,setCheckBool] = React.useState(false)

    React.useEffect(() => {
        setTimeout(() => { window.scrollTo(0, 0); }, 500);
        const initCurrency = currency === null ? '$' : currency; // fix
        const initDonationSum = parseFloat(donationSum) >= 0 ? donationSum : 0;
        document.getElementById('donation-amount').value = initDonationSum;
        doAllCalculation(parseFloat(initDonationSum), initCurrency, 'stripe', 'Credit Card'); // banquest
        getPartnerSlug();
        getCampaignData();
        createUpdateDonation();
    }, [campaignSlug]);

    /* React.useEffect(() => {
        getClientIP();
        console.log('clientIP', clientIP);
    }); */

    const options = {
        appearance,
        clientSecret: stripeIntentID,
    };

    return (
        <main className="main" style={{ background:'#e5e5e530'}}>
            {termsPopup ? (<TermsPopup updateTermsPopup={updateTermsPopup} />) : ''}
            <div className="main__body">
                <div className="container">
                    <div className="main__head">
                        <h1 className="t-center rubik weight-600 f-54 color-1 _anim-items _fadeScale" data-animate-delay="0    "><span>DONATE</span></h1>
                        <h2 className="rubik weight-400 f-30 color-5 t-center _anim-items _fadeUp" data-animate-delay="02">GENERAL DONATION</h2>
                    </div>

                    <div className="donate-page">
                        <div className="fieldset-body  _anim-items _fadeUp" data-animate-delay="02">
                        <div className="fieldset  _anim-items _fadeUp" data-animate-delay="02">
                            <div className="fieldset__title">
                                <img src="/img/hearthnds.png" alt="" />
                                <span>DONATION AMOUNT</span>
                            </div>
                        </div>
                            <div className="donate-page__donate-form donate-form donate-form--lg">
                                {/* <div className="donate-form__buttons">
                                    <div className="donate-form__plus"></div>
                                    <div className="donate-form__minus"></div>
                                </div> */}
                                <div className={currencyOpen ? 'donate-form__sel form-sel _open' : 'donate-form__sel form-sel'}>
                                    <div className="form-sel__button" onClick={toggleCurrency}>{currencyIndicator}</div>
                                    <div className="form-sel__drop _open">
                                        {currencyList?.map((item) => (
                                            <div className="form-sel__drop-item" onClick={() => doAllCalculation(null, item)}>{item}</div>
                                        ))}
                                    </div>
                                </div>
  
                                <input style={{ boxShadow: '0px 4px 30px rgba(0, 0, 0, 0.04)' }} type="text" id="donation-amount" onChange={updateDonationAmount} className="donate-form__input" />
                            </div>
                            <div className="donate-page__donate-form donate-form donate-form--lg">
                                            <div className="form-field  form-insel">
                                                <div className="flex align-center bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                                                <img src={UserIcon} alt="" />
                                                    <input placeholder="Display Name" type="text" className="border-none input color-4 weight-400 f-16 roboto f-normal" id="display-name"/>
                                                </div>
                                            </div>
                                        </div>               
                            <div className="don-wrap">
                                <div className="don-wrap__input">
                                    <div className="form-field form-insel">
                                        {/* <input type="text" className="form-insel__input" id="display-name" /> */}
                                        <div className="form-text" style={{ color:'#ED604F', fontSize:'16px',fontFamily:'Roboto'}}>
                                            The name that will appear in the list of donors on the campaign page.</div>
                                    </div>
                                </div>
                                </div>
                                <div className="don-wrap">
                                    <label className="switch">
                                        <input type="checkbox" id="anonymous-checkbox" />
                                        <span className="slider1 round ">
                                        </span>
                                        
                                    </label>
                                    <p style={{ color: '#1D1E1D', fontSize:'16px', fontFamily:'rubik', marginLeft:'10px' }}>I prefer to remain
                                            Anonymous</p>
                                </div>
                            
                        </div>

                        <div className="fieldset  _anim-items _fadeUp" data-animate-delay="02">
                            <div className="fieldset__title">
                                <img src="/img/fildset-2.png" alt="" />
                                <span>Donor details</span>
                            </div>
                        </div>

                        <div className="fieldset-body  _anim-items _fadeUp" data-animate-delay="02">
                            {/* <div className="form-grid">
                                <div className="form-grid__item col-6">
                                    <div className="form-field form-insel">
                                        <label className="form-legend">First Name <span className="star-t">*</span></label>
                                        <input onChange={() => validateForm(['first-name'])} type="text" id="first-name" className="form-insel__input" />
                                        <div className="form-text">(The name that will appear in the receipt) </div>
                                    </div>
                                </div>

                                <div className="form-grid__item col-6">
                                    <div className="form-field form-insel">
                                        <label className="form-legend">Last Name <span className="star-t">*</span></label>
                                        <input type="text" onChange={() => validateForm(['last-name'])} id="last-name" className="form-insel__input" />
                                    </div>
                                </div>

                                <div className="form-grid__item col-6">
                                    <div className="form-field form-insel">
                                        <label className="form-legend">Cell</label>
                                        <input type="text" onChange={() => validateForm(['phone-number'])} id="phone-number" className="form-insel__input" />
                                    </div>
                                </div>

                                <div className="form-grid__item col-6">
                                    <div className="form-field form-insel">
                                        <label className="form-legend">Email address <span className="star-t">*</span></label>
                                        <input type="text" onChange={() => validateForm(['email'])} id="email" className="form-insel__input" />
                                    </div>
                                </div>
                                <div className="form-grid__item col-6">
                                    <div className="form-field form-insel">
                                        <label className="form-legend">Donation Note </label>
                                        <input type="text" id="donation-note" className="form-insel__input" />
                                    </div>
                                </div>
                            </div>
                             */}
                             <div className='donate-page__donate-form' style={{ maxWidth:' 97rem'}}>

                             <div className="form-grid">
                                        <div className="form-grid__item col-6">
                                            <div className="form-field  form-insel">
                                                <div className="flex align-center bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                                                <img src={UserIcon} alt="" />
                                                <input placeholder="First Name" type="text" className="border-none input color-4 weight-400 f-16 roboto f-normal" onChange={() => validateForm(['first-name'])} id="first-name"  />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-grid__item col-6">
                                            <div className="form-field  form-insel">
                                                <div className="flex align-center bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                                                <img src={UserIcon} alt="" />
                                                    <input placeholder="Last Name" type="text" className="border-none input color-4 weight-400 f-16 roboto f-normal" onChange={() => validateForm(['last-name'])} id="last-name"  />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-grid__item col-6">
                                            <div className="form-field  form-insel">
                                                <div className="flex align-center bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                                                <img src={PhoneIcon} alt="" />
                                                    <input placeholder="Phone Number" type="text" className="border-none input color-4 weight-400 f-16 roboto f-normal" onChange={() => validateForm(['phone'])} id="phone"  />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-grid__item col-6">
                                            <div className="form-field  form-insel" >
                                                <div className="flex align-center bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                                                <img src={EmailIcon} alt="" />
                                                    <input placeholder="E-Mail" className="border-none input color-4 weight-400 f-16 roboto f-normal" type="text"  onChange={() => validateForm(['email'])} id="email" v />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                        </div>

                        {/*   <div className="fieldset _anim-items _fadeUp" data-animate-delay="02">
								<div className="fieldset__title">
									<img src="/img/fildset-3.png" alt="" />
									<span>Give Your Donation as a Merit For</span>
								</div>
							</div>

							<div className="fieldset-body  _anim-items _fadeUp" data-animate-delay="02">
								<div className="form-grid">
									<div className="form-grid__item col-6">
										<div className="form-field form-insel">
											<div className="selectbox ">
												<div className="selectbox__head">
													<div className="selectbox__text">request </div>
													<div className="selectbox__caret"></div>
												</div>
												<div className="selectbox__drop">
													<ul>
														<li className="_selected">request</li>
														<li>request</li>
														<li>request</li>
													</ul>
												</div>
											</div>
										</div>
									</div>

									<div className="form-grid__item col-6">
										<div className="form-field form-insel">
											<input type="text" className="form-insel__input" placeholder="Add Name Here..." />
										</div>
									</div>
								</div>
							</div> */}
                            <div className="fieldset  _anim-items _fadeUp" data-animate-delay="02">
                            <div className="fieldset__title">
                                <img src="/img/handsdol.png" alt="" />
                                <span>Summery and Payment</span>
                            </div>
                        </div>
                        <div className="fieldset-body _anim-items _fadeUp" data-animate-delay="02">
                            {/* {campaign?.isTipGeneral ? (
                                <>
                                    <div className="fieldset _anim-items _fadeUp" data-animate-delay="02">
                                        <div className="fieldset__title">
                                            <img src="/img/fildset-4.png" alt="" />
                                            <span>THE WORLD OF TZEDAKA NEEDS YOUR HELP!</span>
                                        </div>
                                    </div>

                                    <div className="fev-wrap">
                                        <p className="fev-wrap__text">World of Tzedaka also has many cases of tragedies that we are not able to publicize. Please consider adding a donation to our general tzeadakah fund.</p>

                                        <div className="fev-wrap__row">
                                            <div className="fev-wrap__label">
                                                GENERAL DONATION AMOUNT
                                            </div>
                                            <div className="fev-wrap__input">
                                                <div className="fev-wrap__donate-form donate-form donate-form--default ">
                                                    <div className="donate-form__sel form-sel form-sel--dark ">
                                                        <div className="form-sel__drop">
                                                            <div className="form-sel__drop-item">$ USD</div>
                                                            <div className="form-sel__drop-item">$ USD</div>
                                                        </div>
                                                    </div>
                                                    <div className="donate-form__wrap-input">
                                                        <input type="text" onChange={() => doAllCalculation(null)} id="general-tip" className="donate-form__input" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : ''} */}

                            <div className="fev-buttons">
                                <label className="radio-button" onClick={() => doAllCalculation(null, null, null, 'Credit Card')}>
                                    <input type="radio" name="fev-radio" value="Credit Card" id="payment-method-radio-id-Credit Card" />
                                    <span className="radio-button__text">
                                        <span className="radio-button__img"><img src="/img/card-c.png" alt="" /></span>
                                        <span className="color-4 roboto weight-400 f-16">To donate by credit card</span>
                                    </span>
                                </label>
                                {openPaypal ? (
                                    <label className="radio-button" onClick={() => doAllCalculation(null, null, null, 'paypal')}>
                                        <input type="radio" name="fev-radio" value="paypal" id="payment-method-radio-id-paypal" />
                                        <span className="radio-button__text">
                                            <span className="radio-button__img"><img src="/img/bi_paypal.png" alt="" /></span>
                                            <span className="color-4 roboto weight-400 f-16">To donate by PayPal</span>
                                        </span>
                                    </label>
                                ) : ''}
                                {/* openACH ? (
                                    <label className="radio-button" onClick={() => doAllCalculation(null, null, null, 'check')}>
                                        <input type="radio" name="fev-radio" value="check" id="payment-method-radio-id-check" />
                                        <span className="radio-button__text">
                                            <span className="radio-button__img"><img src="/img/fev-btn-img-3.png" alt="" /></span>
                                            <span>To donate by ACH</span>
                                        </span>
                                    </label>
                                ) : ''}
                                {/* openDonorFund ? (
                                    <label className="radio-button" onClick={() => doAllCalculation(null, null, null, 'donorFund')}>
                                        <input type="radio" name="fev-radio" value="donorFund" id="payment-method-radio-id-check" />
                                        <span className="radio-button__text">
                                            <span className="radio-button__img"><img src="/img/fev-btn-img-3.png" alt="" /></span>
                                            <span>To donate by Donor Fund</span>
                                        </span>
                                    </label>
                                ) : '' */}
                            </div>

                            <div className="contribution-wrapper">
                                <div className="contribution">
                                    {openReccuringPayments ? (
                                        <div className="contribution-radio-wrapper">
                                            <label className="radio-button" onClick={() => selectReccuringMode('single')}>
                                                <input type="radio" name="payment-mode" value="single" id="single-payment-mode" />
                                                <span className="radio-button__text1">
                                                    <span>Single Contribution</span>
                                                </span>
                                            </label>
                                            <label className="radio-button" onClick={() => selectReccuringMode('recurring')}>
                                                <input type="radio" name="payment-mode" value="recurring" id="reccuring-payment-mode" />
                                                <span className="radio-button__text1">
                                                    <span>Recurring Contribution</span>
                                                </span>
                                            </label>
                                        </div>
                                    ) : ''}
                                    {openReccuringPayments && reccuringModeIndicator === 'recurring' ? (
                                        <>
                                            <div className="contribution-select-per">
                                                {recurringTermsList.map((item, index) => (
                                                    <div
                                                        className={item === reccuringTerm ? 'contribution-select-per-item active' : 'contribution-select-per-item'}
                                                        onClick={() => selectRecurringTerm(item)}
                                                    >{item}</div>
                                                ))}
                                            </div>
                                            <div className="contribution-text">
                                                <div className="big-text">
                                                    After how many recurrences should the donation end?
                                                    <div class="small-select-wrapper">
                                                        <div className="small-select" onClick={togglePaymentsNum}>
                                                            {maxPayments}
                                                        </div>
                                                        <div className={paymentsNumOpen ? 'small-select-items _open' : 'small-select-items'}>
                                                            <div className="small-select-item" onClick={() => selectMaxPayments('ongoing')}>Ongoing</div>
                                                            {paymentNumList.map((item, index) => (
                                                                <div className="small-select-item" onClick={() => selectMaxPayments(index + 1)}>{index + 1}</div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                                To cancel recurring donations at any time, please send request to support@worldoftzedaka.org
                                            </div>
                                        </>
                                    ) : ''}
                                </div>
                            </div>

                            {campaign?.isTipPercent ? (
                                <div className="don-wrap" style={{marginTop: '40px'}}>
                                    <label className="switch">
                                        <input type="checkbox" id="percent-tip" onChange={() => doAllCalculation(null)} />
                                        <span className="slider1 round ">
                                        </span>
                                        
                                    </label>
                                    <p style={{ color: '#1D1E1D', fontSize:'16px', fontFamily:'rubik', marginLeft:'10px' }}>Help offset the cost of this transaction by adding {currencyIndicator}{tipPercentValue}</p>
                                </div>
                               
                            ) : ''}

                            <div className="don-wrap" style={{marginTop: '20px'}}>
                                    <label className="switch">
                                        <input  onChange={(e) => setCheckBool(e.target.checked)} type='checkbox' className="form-insel__input" />
                                        <span className="slider1 round ">
                                        </span>
                                    </label>
                                    <div className="inputtext" style={{marginLeft:'5px'}}>
                                                <label className="rubik weight-400 f-16">Add a <span className='weight-600'>public</span> donation Note</label> 
                                    {
                                            checkBool && (
                                                <>
                                                
                                                <input type="text" placeholder='Enter your note'  className="form-insel__input1" id="donation-note" />
                                                
                                                </>
                                            )
                                        }
                                        </div>
                                </div>
                                <div className='fev-buttons'>
                            <div className="form-section">
                                <div className="form-field" style={{marginTop: '40px'}}>
                                    <label className="checkbox">
                                        <input type="checkbox" onChange={() => validateForm(['terms-checkbox'])} className="form-insel__input" id="terms-checkbox" last-name />
                                        <span className="checkbox__textterm"> <div className="link-like color-4 rubik weight-400 f-16" onClick={() => updateTermsPopup(true)}> I agree to terms*</div></span>
                                    </label>
                                </div>
                                
                                <h2 className="form-section__label weight-500 color-6" style={{ marginTop: '40px', fontSize: '30px', fontFamily:'rubik',color:'#ED604F' }}>Your Donation:</h2>
                                <p style={{color: '#1979BE', fontWeight:'500px',marginBottom:'0'}}>
                                    Campaign name:<span style={{fontSize: '22px', fontFamily:'roboto', color:'#1D1E1D' , textTransform:'uppercase'}}> {campaign?.name}</span>
                                </p>
                                <p style={{color: '#1979BE', fontWeight:'500px',marginBottom:'0'}}>
                                    Donation: <span style={{fontSize: '22px', fontFamily:'roboto', color:'#1D1E1D' , textTransform:'uppercase'}}>{currencyIndicator}{donationSumIndicator}</span>
                                </p>
                                {tipGeneral ? (
                                    <p style={{color: '#1979BE', fontWeight:'500px',marginBottom:'0'}}>
                                        General Donation:<span style={{fontSize: '22px', fontFamily:'roboto', color:'#1D1E1D' , textTransform:'uppercase'}}> {currencyIndicator}{tipGeneral}</span>
                                    </p>
                                ) : ''}
                                {tipPercent ? (
                                    <p style={{color: '#1979BE', fontWeight:'500px',marginBottom:'0'}}>
                                        Transaction Fee:<span style={{fontSize: '22px', fontFamily:'roboto', color:'#1D1E1D' , textTransform:'uppercase'}}> {currencyIndicator}{tipPercent}</span>
                                    </p>
                                ) : ''}
                                <p style={{color: '#1979BE', fontWeight:'500px',marginBottom:'0'}}>
                                    Total: <span style={{fontSize: '22px', fontFamily:'roboto', color:'#1D1E1D' ,  textTransform:'uppercase'}}> {currencyIndicator}{donationTotal}</span>
                                </p>
                            </div>
                            </div>
                         {/*    <form>
                                <ReCAPTCHA
                                    id="captcha-test"
                                    sitekey="6LceSFshAAAAAMn6P6BswcspvcXhdAZlixCoWNnv"
                                    onChange={isCaptchaValid}
                                />
                            </form> */}
                            {paymentMethod === 'Credit Card' && stripeIntentID === null /* && currencyIndicator !== '$' */ ? (
                                <div className='checkbtn'>
                                <span onClick={getSecret} className="">Donate {'>'}</span>
                                </div>
                            ) : ''}

                            {paymentMethod === 'paypal' && openPaypalCheckout === false && currencyIndicator === '$' ? (
                                <div className='checkbtn'>
                                <span onClick={getSecretPayPal} className="" style={{ }}>Donate {'>'}</span>
                                </div>
                            ) : ''}

                            {stripeIntentID && paymentMethod === 'Credit Card' /* && currencyIndicator !== '$' */ ? (
                                <Elements stripe={stripePromise} options={options}>
                                    <CheckoutForm doValidate={pay} donationID={donationID} />
                                </Elements>
                            ) : ''}
                            {paymentMethod === 'check' ? (
                                <BanquestCheck
                                    doValidate={pay}
                                    amount={donationTotal}
                                    invoiceNumber={donationID}
                                    paymentMode="regular-donation"
                                    reccuringMode={reccuringModeIndicator}
                                    reccuringTerm={reccuringTerm}
                                />
                            ) : ''}
                            {paymentMethod === 'donorFund' ? (
                                <DonorFund
                                    doValidate={pay}
                                    amount={donationTotal}
                                    invoiceNumber={donationID}
                                    paymentMode="regular-donation"
                                    reccuringMode={reccuringModeIndicator}
                                    reccuringTerm={reccuringTerm}
                                />
                            ) : ''}
                            {/* paymentMethod === 'Credit Card' && currencyIndicator === '$' ? (
                                <BanquestCreditCard
                                    doValidate={pay}
                                    amount={donationTotal}
                                    invoiceNumber={donationID}
                                    paymentMode="regular-donation"
                                    reccuringMode={reccuringModeIndicator}
                                    reccuringTerm={reccuringTerm}
                                />
                            ) : '' */ }
                            {paymentMethod === 'paypal' && openPaypalCheckout === true ? (
                                <div className="form-section" style={{ textAlign: 'center' }}>
                                    <PayPalScriptProvider options={{
                                        'client-id': 'AdcSvlP8LBPOpwYFT-c05RqbmYVMyJCfWKUNuyGrUYvP07IbsNiff1C5TIAZwfbf1G2keGNPRne0Cnii' // Live
                                        //  'client-id': 'AbiWxNrBfnECOxXwHZZdNqQF1N4CPHgCZkrDNtWen7Ofav9bEHV1Cvi3PWSPxYLuLzNYUypnFPEOxesu' // Test
                                    }}
                                    >
                                        <PayPalButtons
                                            style={{ layout: 'horizontal', color: 'blue', tagline: false }}
                                            createOrder={createOrder}
                                            onApprove={onApprovePaypal}
                                        />
                                    </PayPalScriptProvider>
                                </div>
                            ) : ''}
                        </div>

                    </div>
                </div>
            </div>
        </main>
    );
}
